/* Royal Perfumierie — theme.js */
(function () {
  'use strict';
  var T = window.theme || {};
  var R = T.routes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartJs: '/cart.js', cart: '/cart' };

  function money(cents) { return '$' + (Math.round(cents) / 100).toFixed(2); }
  function el(sel, ctx) { return (ctx || document).querySelector(sel); }
  function els(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Mobile menu ---------- */
  var burger = el('[data-menu-toggle]'), nav = el('[data-menu]');
  if (burger && nav) burger.addEventListener('click', function () { nav.classList.toggle('is-open'); });
  els('.ge-nav__item.has-children > a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width:900px)').matches) { e.preventDefault(); a.parentElement.classList.toggle('is-open'); }
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = el('#CartDrawer');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('drawer-open'); } }

  function updateFreeShip(total) {
    if (!T.freeShipEnabled) return;
    var bar = el('[data-freeship]'); if (!bar) return;
    var thr = T.freeShipThreshold || 0;
    var msg = el('[data-freeship-msg]'), fill = el('[data-freeship-fill]');
    if (thr <= 0) { bar.style.display = 'none'; return; }
    var pct = Math.min(100, Math.round((total / thr) * 100));
    if (fill) fill.style.width = pct + '%';
    if (total >= thr) { if (msg) msg.innerHTML = '\u{1F389} You\u2019ve unlocked <strong>FREE shipping!</strong>'; }
    else { if (msg) msg.innerHTML = 'Spend <strong>' + money(thr - total) + '</strong> more for <strong>FREE shipping</strong>'; }
  }

  function cartItemHTML(it) {
    return '<div class="cd-item" data-key="' + it.key + '">' +
      '<a class="cd-item__img" href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '" alt="" width="64" height="80">' : '') + '</a>' +
      '<div class="cd-item__info">' +
        '<a class="cd-item__title" href="' + it.url + '">' + it.product_title + '</a>' +
        (it.variant_title && it.variant_title.indexOf('Default') === -1 ? '<p class="cd-item__variant">' + it.variant_title + '</p>' : '') +
        '<div class="cd-item__qty"><button type="button" data-qty-dec aria-label="Decrease">\u2212</button><span>' + it.quantity + '</span><button type="button" data-qty-inc aria-label="Increase">+</button></div>' +
      '</div>' +
      '<div class="cd-item__right"><span class="cd-item__price">' + money(it.final_line_price) + '</span><button type="button" class="cd-item__remove" data-qty-remove aria-label="Remove">Remove</button></div>' +
    '</div>';
  }

  function renderCart(cart) {
    els('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    var sub = el('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
    var items = el('[data-cart-items]'), foot = el('[data-cart-foot]'), empty = el('[data-cart-empty]');
    if (cart.item_count === 0) {
      if (items) items.innerHTML = ''; if (foot) foot.hidden = true; if (empty) empty.hidden = false;
      var fb = el('[data-freeship]'); if (fb) fb.style.display = 'none';
    } else {
      if (items) items.innerHTML = cart.items.map(cartItemHTML).join('');
      if (foot) foot.hidden = false; if (empty) empty.hidden = true;
      var fb2 = el('[data-freeship]'); if (fb2) fb2.style.display = '';
      updateFreeShip(cart.total_price); bindItemControls();
    }
  }

  function fetchCart(cb) {
    fetch(R.cartJs, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); if (cb) cb(cart); }).catch(function () {});
  }
  function changeQty(key, qty) {
    fetch(R.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  function bindItemControls() {
    els('.cd-item').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var qtySpan = el('.cd-item__qty span', row);
      var cur = parseInt(qtySpan ? qtySpan.textContent : '1', 10) || 1;
      var inc = el('[data-qty-inc]', row), dec = el('[data-qty-dec]', row), rem = el('[data-qty-remove]', row);
      if (inc) inc.onclick = function () { changeQty(key, cur + 1); };
      if (dec) dec.onclick = function () { changeQty(key, cur - 1); };
      if (rem) rem.onclick = function () { changeQty(key, 0); };
    });
  }
  function addToCart(id, qty, openAfter) {
    return fetch(R.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
      .then(function (r) { return r.json(); }).then(function () { fetchCart(function () { if (openAfter && T.cartDrawer) openDrawer(); }); });
  }

  els('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { if (T.cartDrawer) { e.preventDefault(); fetchCart(); openDrawer(); } }); });
  els('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeQuickView(); } });

  els('.product-card__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]'); if (!idInput) { form.submit(); return; }
      var btn = form.querySelector('button'); var orig = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
      addToCart(idInput.value, 1, true).then(function () { if (btn) { btn.textContent = 'Added \u2713'; setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1200); } }).catch(function () { form.submit(); });
    });
  });

  /* ---------- Product page ---------- */
  var mainImg = el('#ProductMainImage');
  if (mainImg) {
    els('.product-page__thumb').forEach(function (t) { t.addEventListener('click', function () { var f = t.getAttribute('data-full'); if (f) mainImg.src = f; }); });
    mainImg.style.transition = 'transform .2s';
    mainImg.addEventListener('mousemove', function (e) { var r = mainImg.getBoundingClientRect(); mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; });
    mainImg.addEventListener('mouseenter', function () { mainImg.style.transform = 'scale(1.8)'; });
    mainImg.addEventListener('mouseleave', function () { mainImg.style.transform = 'scale(1)'; });
  }
  var pForm = el('#ProductForm');
  if (pForm) {
    var vs = el('#ProductVariant');
    if (vs) vs.addEventListener('change', function () { var o = vs.options[vs.selectedIndex]; var b = pForm.querySelector('button[type="submit"]'); if (b) b.disabled = o.disabled; });
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = (pForm.querySelector('[name="id"]') || {}).value;
      var qty = parseInt((pForm.querySelector('[name="quantity"]') || {}).value || '1', 10);
      if (!id) return;
      addToCart(id, qty, true).catch(function () { pForm.submit(); });
    });
  }

  /* ---------- Quick view ---------- */
  var qv = el('#QuickView');
  function closeQuickView() { if (qv) { qv.classList.remove('is-open'); qv.setAttribute('aria-hidden', 'true'); } }
  function openQuickView() { if (qv) { qv.classList.add('is-open'); qv.setAttribute('aria-hidden', 'false'); } }
  function renderQuickView(p) {
    var body = el('[data-qv-body]'); if (!body) return;
    var v = p.variants[0];
    var opts = p.variants.map(function (x) { return '<option value="' + x.id + '"' + (x.available ? '' : ' disabled') + '>' + x.title + ' \u00b7 ' + money(x.price) + (x.available ? '' : ' (sold out)') + '</option>'; }).join('');
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    body.innerHTML =
      '<div class="qv-grid"><div class="qv-media">' + (img ? '<img src="' + img + '" alt="' + p.title + '">' : '') + '</div>' +
      '<div class="qv-info"><h2 class="qv-title">' + p.title + '</h2>' +
      (p.type ? '<p class="qv-type">' + p.type + '</p>' : '') +
      '<div class="qv-price">' + money(p.price) + (p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : '') + '</div>' +
      '<p class="qv-stock">' + (p.available ? '<span class="in-stock">In stock</span>' : '<span class="out-stock">Out of stock</span>') + '</p>' +
      (p.variants.length > 1 ? '<select class="qv-select">' + opts + '</select>' : '<input type="hidden" class="qv-select" value="' + v.id + '">') +
      '<div class="qv-buy"><input type="number" class="qv-qty" value="1" min="1"><button type="button" class="btn btn--accent qv-add"' + (p.available ? '' : ' disabled') + '>' + (p.available ? 'Add to Cart' : 'Sold Out') + '</button></div>' +
      '<a class="qv-full" href="/products/' + p.handle + '">View full details</a></div></div>';
    var sel = el('.qv-select', body), qty = el('.qv-qty', body), add = el('.qv-add', body);
    if (add) add.addEventListener('click', function () {
      var id = sel ? (sel.value || (sel.options && sel.options[sel.selectedIndex].value)) : v.id;
      var q = parseInt(qty ? qty.value : '1', 10) || 1;
      add.disabled = true; add.textContent = 'Adding\u2026';
      addToCart(id, q, true).then(function () { closeQuickView(); }).catch(function () {});
    });
  }
  els('[data-qv-close]').forEach(function (b) { b.addEventListener('click', closeQuickView); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-quick-view]');
    if (!t || !T.quickView) return;
    e.preventDefault();
    var handle = t.getAttribute('data-quick-view');
    var body = el('[data-qv-body]'); if (body) body.innerHTML = '<div class="quick-view__loading">Loading\u2026</div>';
    openQuickView();
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderQuickView)
      .catch(function () { if (body) body.innerHTML = '<p style="padding:30px">Could not load product.</p>'; });
  });

  /* ---------- Collection sort + filters ---------- */
  var sortSel = el('[data-sort-select]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page');
    window.location.href = u.toString();
  });
  var fToggle = el('[data-filters-toggle]'), filters = el('[data-filters]');
  if (fToggle && filters) fToggle.addEventListener('click', function () { filters.classList.toggle('is-open'); });

  /* ---------- Carousel (best sellers / featured / dual sides) ---------- */
  function setupCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;
    function step() {
      var slide = track.querySelector('.ge-carousel__slide');
      if (!slide) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 16;
      return slide.getBoundingClientRect().width + gap;
    }
    function updateButtons() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-carousel]'), setupCarousel);

  /* ---------- Tabs (tabbed-products section) ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-tabs]'), function (tabs) {
    var section = tabs.closest('section');
    if (!section) return;
    var buttons = tabs.querySelectorAll('[data-tab]');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');
        Array.prototype.forEach.call(buttons, function (b) { b.classList.toggle('is-active', b === btn); });
        Array.prototype.forEach.call(section.querySelectorAll('[data-panel]'), function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === target);
        });
      });
    });
  });

  /* ---------- Filter sidebar: search input filters its list ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-filter-search]'), function (input) {
    var list = input.parentNode.querySelector('[data-filter-list]');
    if (!list) return;
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      Array.prototype.forEach.call(list.querySelectorAll('.filter-list__item'), function (li) {
        var label = (li.textContent || '').toLowerCase();
        li.classList.toggle('is-search-hidden', q !== '' && label.indexOf(q) === -1);
      });
    });
  });

  /* ---------- Filter sidebar: dual-handle price range slider ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-price-slider]'), function (slider) {
    var minHandle = slider.querySelector('[data-price-handle-min]');
    var maxHandle = slider.querySelector('[data-price-handle-max]');
    var rangeFill = slider.querySelector('[data-price-range]');
    var display = slider.parentNode.querySelector('[data-price-display]');
    var minInput = slider.parentNode.querySelector('[data-price-min-input]');
    var maxInput = slider.parentNode.querySelector('[data-price-max-input]');
    if (!minHandle || !maxHandle) return;
    var lo = Number(slider.dataset.min || 0);
    var hi = Number(slider.dataset.max || 100);
    var span = hi - lo;
    function clamp(n) { return Math.max(lo, Math.min(hi, n)); }
    function paint(a, b) {
      var lp = span ? ((a - lo) / span) * 100 : 0;
      var rp = span ? ((b - lo) / span) * 100 : 100;
      rangeFill.style.left = lp + '%';
      rangeFill.style.right = (100 - rp) + '%';
    }
    function fromHandles() {
      var a = Number(minHandle.value), b = Number(maxHandle.value);
      if (a > b) {
        if (this === minHandle) { a = b; minHandle.value = a; }
        else { b = a; maxHandle.value = b; }
      }
      if (minInput) minInput.value = a;
      if (maxInput) maxInput.value = b;
      paint(a, b);
    }
    function fromInputs() {
      var a = clamp(Number(minInput.value) || lo);
      var b = clamp(Number(maxInput.value) || hi);
      if (a > b) { var t = a; a = b; b = t; }
      minHandle.value = a; maxHandle.value = b;
      minInput.value = a; maxInput.value = b;
      paint(a, b);
    }
    var update = fromHandles;
    minHandle.addEventListener('input', fromHandles);
    maxHandle.addEventListener('input', fromHandles);
    if (minInput) { minInput.addEventListener('change', fromInputs); minInput.addEventListener('blur', fromInputs); }
    if (maxInput) { maxInput.addEventListener('change', fromInputs); maxInput.addEventListener('blur', fromInputs); }
    update();
  });

  /* ---------- Collection sort direction toggle ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-sort-direction]'), function (btn) {
    btn.addEventListener('click', function () {
      var sel = document.querySelector('[data-sort-select]');
      if (!sel) return;
      var cur = sel.value || '';
      var next = null;
      if (cur.indexOf('-ascending') > -1) next = cur.replace('-ascending', '-descending');
      else if (cur.indexOf('-descending') > -1) next = cur.replace('-descending', '-ascending');
      if (!next) {
        // Sort has no direction (manual / best-selling) — switch to price-ascending as a sensible default
        next = 'price-ascending';
      }
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', next);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  fetchCart();
})();
